// Debug HUD button — only mounted when ?trackToggle=1 is on the URL.
// Cycles renderer.trackMode between 'plane' (plane-attached anchor,
// current behaviour) and 'world' (manufactured world anchor at
// camera_forward × PREVIEW_DISTANCE_M — the pre-plane-attached
// behaviour, kept for side-by-side UAT under harsh lighting where the
// plane path can be noisier).
//
// Positioned bottom-right so it doesn't overlap the coaching overlay
// or the top controls. pointerEvents: 'auto' so the button is
// clickable through the otherwise-transparent overlay layer.

import { useState, useCallback } from 'react'

export type TrackMode = 'plane' | 'world'

interface TrackModeToggleProps {
  initialMode: TrackMode
  onChange: (mode: TrackMode) => void
}

export function TrackModeToggle({ initialMode, onChange }: TrackModeToggleProps) {
  const [mode, setMode] = useState<TrackMode>(initialMode)
  const cycle = useCallback(() => {
    const next: TrackMode = mode === 'plane' ? 'world' : 'plane'
    setMode(next)
    onChange(next)
  }, [mode, onChange])

  return (
    <button
      type="button"
      data-testid="track-mode-toggle"
      onClick={cycle}
      style={{
        position: 'fixed',
        right: 12,
        bottom: 230,
        zIndex: 200,
        pointerEvents: 'auto',
        background: 'rgba(0, 0, 0, 0.85)',
        color: 'white',
        border: '1px solid rgba(255,255,255,0.25)',
        borderRadius: 999,
        padding: '10px 16px',
        fontSize: 12,
        fontFamily: 'ui-monospace, "SF Mono", Menlo, monospace',
        cursor: 'pointer',
        boxShadow: '0 2px 6px rgba(0,0,0,0.35)',
      }}
    >
      {mode === 'plane' ? 'PLANE' : 'WORLD'}
    </button>
  )
}
